export default { init }

function init(element) {
  const target = document.querySelector(element.dataset.target);
  const hide_when = element.dataset.hideWhen;
  const clear_when_hidden = element.dataset.clearWhenHidden === "true";
  if (!target || !hide_when) {
    console.error(`Missing target or hideWhen attribute.
Usage:
  <input type="checkbox" class="toggle-hidden-action" data-target="#target_id" data-hide_when="checked" />`);
    return;
  }

  switch (element.localName) {
    case 'input':
      if (element.type === 'checkbox') {
        element.addEventListener('change', () => {
          if (hide_when === "checked") {
            const fn = element.checked ? "add" : "remove";
            target.classList[fn]('hidden');
          } else if (hide_when === "unchecked") {
            const fn = element.checked ? "remove" : "add";
            target.classList[fn]('hidden');
          } else {
            console.warn("Unrecognised 'hide_when'. Expected 'checked' or 'unchecked'");
            return;
          }

          if (clear_when_hidden && target.classList.contains('hidden')) {
            target
              .querySelectorAll('input, select, textarea')
              .forEach((field) => { field.value = ""; });
          }
        });
      }
      break;
    default:
      console.warn(`Unsupported element type: ${element.localName}`);
  }
}
